( function() {
	const MAX_VISIBLE = 5;

	const initCollapseOptions = () => {
		document.querySelectorAll( ".filter-panel .filter-items" ).forEach( ( items ) => {
		const itemEls = Array.from( items.children ).filter( ( el ) => el.nodeType === 1 );
		const total = itemEls.length;

		// If 5 or fewer, ensure no toggle state/classes linger and bail.
		if ( total <= MAX_VISIBLE ) {
			items.classList.remove( "is-collapsed", "has-filter-toggle" );
			const maybeToggle = items.nextElementSibling;
			if ( maybeToggle && maybeToggle.classList.contains( "filter-toggle" ) ) {
				maybeToggle.remove();
			}
			return;
		}

		// Mark that this list has a toggle
		items.classList.add( "has-filter-toggle" );

		// Collapse by default
		items.classList.add( "is-collapsed" );

		// If any hidden option is checked, show all so it's visible
		const hiddenChecked = itemEls.slice( MAX_VISIBLE ).some( ( el ) =>
			el.querySelector( 'input[type="checkbox"]:checked' )
		);
		if ( hiddenChecked ) items.classList.remove( "is-collapsed" );

		// Reuse existing toggle if present; otherwise create one
		let toggle = items.nextElementSibling;
		if ( !toggle || !toggle.classList.contains( "filter-toggle" ) ) {
			toggle = document.createElement( "button" );
			toggle.type = "button";
			toggle.className = "filter-toggle";
			items.insertAdjacentElement( "afterend", toggle );
		}

		const setLabel = () => {
			toggle.textContent = items.classList.contains( "is-collapsed" )
								 ? `Show All (${total})`
								 : "Show Less";
		};
		setLabel();

		// Ensure only one click handler is attached
		toggle.onclick = () => {
			items.classList.toggle( "is-collapsed" );
			setLabel();
		};

		// Keep label in sync if a hidden box becomes checked via code
		items.addEventListener( "change", ( e ) => {
			if ( !( e.target instanceof HTMLInputElement ) ) return;
			setLabel();
		} );
		} );
	};

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initCollapseOptions, { once: true } );
	} else {
		initCollapseOptions();
	}
} )();
